/**
 * swoPermissions.ts
 *
 * Pure helper module for Service Work Order (SWO) permission checks.
 */
import { hasPermission } from './crmPermissions';

export const SWO_PERMISSIONS = {
  WORK_ORDER_CREATE: 'operations.work_order:create',
  WORK_ORDER_READ: 'operations.work_order:read',
  WORK_ORDER_UPDATE: 'operations.work_order:update',
  WORK_ORDER_ASSIGN: 'operations.work_order:assign',
  WORK_ORDER_TRANSITION: 'operations.work_order:transition',
  WORK_ORDER_CANCEL: 'operations.work_order:cancel',
} as const;

export function canSeeWorkOrderMenu(permissions: readonly string[]): boolean {
  return hasPermission(permissions, SWO_PERMISSIONS.WORK_ORDER_READ);
}

export { hasPermission };
